var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0709 2.92906C13.1655 -0.976367 6.83363 -0.976367 2.92902 2.92914C-0.976367 6.83453 -0.976367 13.1664 2.92918 17.071C6.83363 20.9764 13.1655 20.9764 17.0709 17.0709C20.9764 13.1664 20.9764 6.83453 17.0709 2.92906ZM15.8925 15.8923C12.6379 19.147 7.36141 19.147 4.1077 15.8925C0.853086 12.6386 0.853086 7.36215 4.10762 4.10762C7.36141 0.853047 12.6379 0.853047 15.8924 4.10762C19.147 7.36219 19.147 12.6386 15.8925 15.8923Z",
    fill: "#7D7D7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1248 5.87542C13.7994 5.54999 13.2717 5.54999 12.9463 5.87542L9.99998 8.82171L7.05369 5.87542C6.72826 5.54999 6.20061 5.54999 5.87518 5.87542C5.54975 6.20085 5.54975 6.72851 5.87518 7.05394L8.82147 10.0002L5.87627 12.9454C5.55084 13.2708 5.55084 13.7985 5.87627 14.1239C6.2017 14.4494 6.72936 14.4494 7.05479 14.1239L9.99998 11.1787L12.946 14.1248C13.2715 14.4502 13.7991 14.4502 14.1246 14.1248C14.45 13.7994 14.45 13.2717 14.1246 12.9463L11.1785 10.0002L14.1248 7.05394C14.4502 6.72851 14.4502 6.20089 14.1248 5.87542Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRounded);
export default __webpack_public_path__ + "static/media/CloseRounded.6ca2125aa62d63ad3ca2531f0d6d3d83.svg";
export { ForwardRef as ReactComponent };